/* ============================================================
   CTP Gallery / Lightbox engine
   Theme asset, referenced once in theme.liquid:
     {{ 'ctp-lightbox.js' | asset_url | script_tag }}
   Styles live in assets/ctp-product-gallery.css — the overlay
   will render as stray text at the bottom of the page without them.

   Two ways in:
   1. Any grid markup on a page:
        <div class="ctp-grid ctp-grid--2col"> ...imgs... </div>
   2. The product page gallery (.product-gallery) — clicking the
      main image opens the lightbox at that image, with every
      product media image in the group.

   Public API: window.CTPLightbox.open(items, index)
     items = [{ src, alt }]
   ============================================================ */
(function () {
  if (window.__ctpGalleryInit) return; // only ever set up once
  window.__ctpGalleryInit = true;

  function init() {
    // Build the lightbox overlay a single time and append to <body>
    var lb = document.createElement('div');
    lb.className = 'ctp-lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-hidden', 'true');
    lb.innerHTML =
      '<button class="ctp-lightbox-close" type="button" aria-label="Close">&times;</button>' +
      '<button class="ctp-lightbox-arrow ctp-lightbox-prev" type="button" aria-label="Previous">&#8249;</button>' +
      '<div class="ctp-lightbox-img-wrap"><img alt=""></div>' +
      '<button class="ctp-lightbox-arrow ctp-lightbox-next" type="button" aria-label="Next">&#8250;</button>' +
      '<div class="ctp-lightbox-counter"></div>';
    document.body.appendChild(lb);

    var lbImg = lb.querySelector('.ctp-lightbox-img-wrap img');
    var closeBtn = lb.querySelector('.ctp-lightbox-close');
    var prevBtn = lb.querySelector('.ctp-lightbox-prev');
    var nextBtn = lb.querySelector('.ctp-lightbox-next');
    var counter = lb.querySelector('.ctp-lightbox-counter');

    var group = []; // [{ src, alt }]
    var current = 0;
    var lastFocus = null;

    function show(i) {
      if (!group.length) return;
      current = (i + group.length) % group.length;
      var item = group[current];

      lb.classList.add('ctp-loading');
      var loader = new Image();
      loader.onload = loader.onerror = function () {
        lb.classList.remove('ctp-loading');
      };
      loader.src = item.src;

      lbImg.src = item.src;
      lbImg.alt = item.alt || '';
      counter.textContent = current + 1 + ' / ' + group.length;
      lb.classList.toggle('ctp-single', group.length < 2);

      // preload neighbours so arrow clicks feel instant
      [current + 1, current - 1].forEach(function (n) {
        var neighbour = group[(n + group.length) % group.length];
        if (neighbour && neighbour.src !== item.src) {
          var pre = new Image();
          pre.src = neighbour.src;
        }
      });
    }

    function open(items, index) {
      if (!items || !items.length) return;
      group = items;
      lastFocus = document.activeElement;
      show(index || 0);
      lb.classList.add('ctp-open');
      lb.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ctp-lightbox-open');
      closeBtn.focus();
    }

    function close() {
      lb.classList.remove('ctp-open');
      lb.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ctp-lightbox-open');
      lbImg.src = '';
      group = [];
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      lastFocus = null;
    }

    window.CTPLightbox = { open: open, close: close };

    /* --------------------------------------------------------
       Source 1: .ctp-grid blocks (unchanged behaviour)
       -------------------------------------------------------- */
    function itemsFromGrid(grid) {
      return Array.prototype.slice.call(grid.querySelectorAll('img')).map(function (img) {
        return { src: img.getAttribute('data-ctp-full') || img.src, alt: img.alt, el: img };
      });
    }

    document.addEventListener('click', function (e) {
      var img = e.target.closest && e.target.closest('.ctp-grid img');
      if (!img) return;
      var items = itemsFromGrid(img.closest('.ctp-grid'));
      var index = 0;
      items.forEach(function (it, i) {
        if (it.el === img) index = i;
      });
      open(items, index);
    });

    /* --------------------------------------------------------
       Source 2: the product gallery
       Each <figure class="product-gallery--media"> carries a
       data-ctp-full attribute with a full-size image URL.
       -------------------------------------------------------- */
    function itemsFromGallery(gallery) {
      var figures = gallery.querySelectorAll(
        '.product-gallery--media[data-media-type="image"]'
      );
      return Array.prototype.slice.call(figures).map(function (fig) {
        var img = fig.querySelector('img');
        return {
          src: fig.getAttribute('data-ctp-full') || (img && (img.currentSrc || img.src)),
          alt: (img && img.alt) || '',
          el: fig
        };
      }).filter(function (it) {
        return !!it.src;
      });
    }

    // Capture phase: the theme's own click-to-zoom handler is bound on
    // the figure, so intercept before it runs rather than fighting it.
    document.addEventListener(
      'click',
      function (e) {
        if (!e.target.closest) return;

        // Never interfere with the thumbnail buttons — those still
        // swap the main image via the theme's gallery script.
        if (e.target.closest('.product-gallery--navigation')) return;

        var fig = e.target.closest('.product-gallery--media[data-media-type="image"]');
        if (!fig) return;

        // Leave the AR / "view in your space" button alone
        if (e.target.closest('.product-gallery--viewinyourspace')) return;

        var gallery = fig.closest('[data-product-gallery]');
        if (!gallery) return;

        e.preventDefault();
        e.stopPropagation();

        var items = itemsFromGallery(gallery);
        var index = 0;
        items.forEach(function (it, i) {
          if (it.el === fig) index = i;
        });
        open(items, index);
      },
      true
    );

    /* --------------------------------------------------------
       Overlay controls
       -------------------------------------------------------- */
    closeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      close();
    });
    prevBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      show(current - 1);
    });
    nextBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      show(current + 1);
    });

    // Click the backdrop (but not the image) to close
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.classList.contains('ctp-lightbox-img-wrap')) close();
    });

    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('ctp-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(current - 1);
      if (e.key === 'ArrowRight') show(current + 1);
      // keep tab focus inside the overlay
      if (e.key === 'Tab') {
        var focusable = [closeBtn, prevBtn, nextBtn].filter(function (el) {
          return el.offsetParent !== null;
        });
        if (!focusable.length) return;
        var i = focusable.indexOf(document.activeElement);
        e.preventDefault();
        var nextIndex = e.shiftKey ? i - 1 : i + 1;
        focusable[(nextIndex + focusable.length) % focusable.length].focus();
      }
    });

    // Swipe between images on touch devices
    var touchStartX = null;
    var touchStartY = null;
    lb.addEventListener(
      'touchstart',
      function (e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      },
      { passive: true }
    );
    lb.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
        dx < 0 ? show(current + 1) : show(current - 1);
      }
      touchStartX = null;
      touchStartY = null;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* ============================================================
   CTP Slideshow  (crossfade + 4s autoplay)
   Unchanged — different class names and its own init guard.

   Page markup only needs:
     <div class="ctp-slideshow">
       <img src="..." alt="...">
       ... more images ...
     </div>
   Arrows, counter, autoplay and swipe are built automatically.
   ============================================================ */
(function () {
  if (window.__ctpSlideshowInit) return; // only ever set up once
  window.__ctpSlideshowInit = true;

  var AUTOPLAY_MS = 4000;
  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(root) {
    var imgs = Array.prototype.slice.call(root.querySelectorAll('img'));
    if (!imgs.length) return;

    var viewport = document.createElement('div');
    viewport.className = 'ctp-slideshow-viewport';

    var track = document.createElement('div');
    track.className = 'ctp-slideshow-track';

    var slides = imgs.map(function (img) {
      var slide = document.createElement('div');
      slide.className = 'ctp-slideshow-slide';
      slide.appendChild(img); // moves the img into its slide
      track.appendChild(slide);
      return slide;
    });
    viewport.appendChild(track);

    var prev = document.createElement('button');
    prev.className = 'ctp-slideshow-arrow ctp-slideshow-prev';
    prev.setAttribute('aria-label', 'Previous');
    prev.innerHTML = '&#8249;';

    var next = document.createElement('button');
    next.className = 'ctp-slideshow-arrow ctp-slideshow-next';
    next.setAttribute('aria-label', 'Next');
    next.innerHTML = '&#8250;';

    viewport.appendChild(prev);
    viewport.appendChild(next);

    var counter = document.createElement('div');
    counter.className = 'ctp-slideshow-counter';
    viewport.appendChild(counter);

    root.innerHTML = '';
    root.appendChild(viewport);

    var current = 0;
    function render() {
      slides.forEach(function (s, i) {
        s.classList.toggle('ctp-active', i === current);
      });
      counter.textContent = current + 1 + ' / ' + imgs.length;
    }
    function go(i) {
      current = (i + imgs.length) % imgs.length;
      render();
    }

    // autoplay
    var timer = null;
    function start() {
      if (reduceMotion || imgs.length < 2) return;
      stop();
      timer = setInterval(function () {
        go(current + 1);
      }, AUTOPLAY_MS);
    }
    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }
    function restart() {
      stop();
      start();
    }

    prev.addEventListener('click', function () {
      go(current - 1);
      restart();
    });
    next.addEventListener('click', function () {
      go(current + 1);
      restart();
    });

    if (imgs.length < 2) {
      prev.style.display = 'none';
      next.style.display = 'none';
      counter.style.display = 'none';
    }

    // pause while hovering
    viewport.addEventListener('mouseenter', stop);
    viewport.addEventListener('mouseleave', start);

    // basic touch swipe (also pauses, then resumes)
    var startX = null;
    viewport.addEventListener(
      'touchstart',
      function (e) {
        startX = e.touches[0].clientX;
        stop();
      },
      { passive: true }
    );
    viewport.addEventListener('touchend', function (e) {
      if (startX !== null) {
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) {
          dx < 0 ? go(current + 1) : go(current - 1);
        }
        startX = null;
      }
      start();
    });

    render();
    start();
  }

  function init() {
    var nodes = document.querySelectorAll('.ctp-slideshow');
    Array.prototype.forEach.call(nodes, setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
